import type { IMarketData } from 'customTypes/marketData';

export const getMarketData = async (currency: string, origin: string = ''): Promise<IMarketData> => {
	try {
		const res = await fetch(`${origin}/api/market-data?referenceCurrency=${currency}`);
		const response = await res.json();
		return { ...response.globalMarketData };
	} catch (error) {
		console.error(error);
		return {
			btcDominance: 0,
			coinsAmount: 0,
			dayVolume: 0,
			exchanges: 0,
			marketCap: 0,
		};
	}
};
